import * as React from "react"
import { Link } from "gatsby"
import EnhanceAndManageTools from "../components/rotating-tools/enhance-and-manage-tools"
import DiagnoseAndFixTools from "./rotating-tools/diagnose-and-fix-tools"
import InsightsTools from "./rotating-tools/insights-tools"
import OptimizeSearchTools from "./rotating-tools/optimize-search"

const RoadmapTabs = (props) => {

    let titleText = 'PROVEN SOLUTIONS TO ACCELERATE YOUR WALMART BUSINESS'
    if(props.title != null){
        titleText = props.title
    }

    let titleColor = 'dark'
    let bodyColor = 'header'
    let tabColor = ''
    if (props.textColor !== undefined) {
        titleColor = props.textColor
        bodyColor = props.textColor
        tabColor = `text-${props.textColor}`
    }

    let tabOneText = []
    if(props.tabOneText != null){
        tabOneText = props.tabOneText.map((text, i) => <li key={i}><p>{text}</p></li>);
    }
    else {
        tabOneText = [
            <li key={0}><p>Easily add enhanced content to your Walmart.com listings</p></li>,
            <li key={1}><p>Overcome publishing issues and update the content on your item pages</p></li>,
            <li key={2}><p>Manage all of your Walmart items from SKU Ninja’s simplified online dashboard</p></li>,
            <li key={3}><p>Save time and resources by having content updated and optimized by former Walmart merchants</p></li>
        ]
    }

    let tabTwoText = []
    if(props.tabTwoText != null){
        tabTwoText = props.tabTwoText.map((text, i) => <li key={i}><p>{text}</p></li>);
    }
    else {
        tabTwoText = [
            <li key={0}><p>View Content Quality Scores and the top issues affecting them</p></li>,
            <li key={1}><p>Meet Walmart content guidelines with complete and accurate attributes</p></li>,
            <li key={2}><p>Monitor your items for missing content and opportunities to improve</p></li>,
            <li key={3}><p>Remove barriers to success with the help of our team of Walmart search experts</p></li>
        ]
    }

    let tabThreeText = []
    if(props.tabThreeText != null){
        tabThreeText = props.tabThreeText.map((text, i) => <li key={i}><p>{text}</p></li>);
    }
    else {
        tabThreeText = [
            <li key={0}><p>Get Walmart-focused data and insights you won’t get anywhere else</p></li>,
            <li key={1}><p>Find unauthorized third-party resellers making sales on your item pages</p></li>,
            <li key={2}><p>Uncover actionable insights on Walmart.com shoppers and competitors</p></li>,
            <li key={3}><p>Devise Walmart search strategies to drive traffic and sales with help from our team of experts</p></li>
        ]
    }

    let tabFourText = []
    if(props.tabFourText != null){
        tabFourText = props.tabFourText.map((text, i) => <li key={i}><p>{text}</p></li>);
    }
    else {
        tabFourText = [
            <li key={0}><p>Simplify your category’s search results and find opportunities to win</p></li>,
            <li key={1}><p>Discover valuable high-traffic SEO keywords used on Walmart.com</p></li>,
            <li key={2}><p>Optimize your search rank with strategies for paid and organic search</p></li>,
            <li key={3}><p>Engage our team of experts to do a deep dive on your portfolio and dominate search results</p></li>
        ]
    }

    return(
        <div data-sal="slide-up" data-sal-delay="0" data-sal-duration='800' data-sal-easing="ease" className='container'>
            <h1 className={`mb-5 text-center text-${titleColor} text-uppercase`}> {titleText} </h1>
            <ul className="nav nav-pills nav-justified mb-4 flex-column flex-sm-row" id="pills-pillar-tabs" role="tablist">
                <li className="nav-item d-flex" role="presentation">
                    <button className={`nav-link nav-teal active ${tabColor}`} id="pills-enhance-and-manage-tab" data-bs-toggle="pill" data-bs-target="#pills-enhance-and-manage" type="button" role="tab" aria-controls="pills-enhance-and-manage" aria-selected="true">Enhance & Manage Content</button>
                </li>
                <li className="nav-item d-flex" role="presentation">
                    <button className={`nav-link nav-teal ${tabColor}`} id="pills-diagnose-and-fix-tab" data-bs-toggle="pill" data-bs-target="#pills-diagnose-and-fix" type="button" role="tab" aria-controls="pills-diagnose-and-fix" aria-selected="false">Diagnose & Fix Issues</button>
                </li>
                <li className="nav-item d-flex" role="presentation">
                    <button className={`nav-link nav-teal ${tabColor}`} id="pills-insights-tab" data-bs-toggle="pill" data-bs-target="#pills-insights" type="button" role="tab" aria-controls="pills-insights" aria-selected="false">Analytical Insights</button>
                </li>
                <li className="nav-item d-flex" role="presentation">
                    <button className={`nav-link nav-teal ${tabColor}`} id="pills-optimize-search-tab" data-bs-toggle="pill" data-bs-target="#pills-optimize-search" type="button" role="tab" aria-controls="pills-optimize-search" aria-selected="false">Search Optimization</button>
                </li>
            </ul>

            <div className="tab-content" id="pills-pillar-content">
                <div className="tab-pane fade show active" id="pills-enhance-and-manage" role="tabpanel" aria-labelledby="pills-enhance-and-manage-tab">
                    <div className='row mb-4'>
                        <div className='col-lg-8 col-md-6 col-xs-12 d-flex my-auto'>
                            <ol className={`list-style-inherit text-${bodyColor}`}>
                                {tabOneText}
                            </ol>
                        </div>
                        <div className='col-lg-4 col-md-6 col-xs-12 d-flex justify-content-center'>
                            <EnhanceAndManageTools/>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <Link to='/software/roadmap#enhance-and-manage' className=' mx-auto'><button className='btn btn-yellow'>Learn More</button></Link>
                    </div>
                </div>
                <div className="tab-pane fade" id="pills-diagnose-and-fix" role="tabpanel" aria-labelledby="pills-diagnose-and-fix-tab">
                    <div className='row mb-4'>
                        <div className='col-lg-8 col-md-6 col-xs-12 d-flex my-auto'>
                            <ol className={`list-style-inherit text-${bodyColor}`}>
                                {tabTwoText}
                            </ol>
                        </div>
                        <div className='col-lg-4 col-md-6 col-xs-12 d-flex justify-content-center'>
                            <DiagnoseAndFixTools className='w-80 tool-abstraction'/>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <Link to='/software/roadmap#diagnose-and-fix' className=' mx-auto'><button className='btn btn-yellow'>Learn More</button></Link>
                    </div>
                </div>
                <div className="tab-pane fade" id="pills-insights" role="tabpanel" aria-labelledby="pills-insights-tab">
                <div className='row mb-4'>
                        <div className='col-lg-8 col-md-6 col-xs-12 d-flex my-auto'>
                            <ol className={`list-style-inherit text-${bodyColor}`}>
                                {tabThreeText}
                            </ol>
                        </div>
                        <div className='col-lg-4 col-md-6 col-xs-12 d-flex justify-content-center'>
                            <InsightsTools className='w-80 tool-abstraction'/>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <Link to='/software/roadmap#analytical-insights' className=' mx-auto'><button className='btn btn-yellow'>Learn More</button></Link>
                    </div>
                </div>
                <div className="tab-pane fade" id="pills-optimize-search" role="tabpanel" aria-labelledby="pills-optimize-search-tab">
                <div className='row mb-4'>
                        <div className='col-lg-8 col-md-6 col-xs-12 d-flex my-auto'>
                            <ol className={`list-style-inherit text-${bodyColor}`}>
                                {tabFourText}
                            </ol>
                        </div>
                        <div className='col-lg-4 col-md-6 col-xs-12 d-flex justify-content-center'>
                            <OptimizeSearchTools className='w-80 tool-abstraction'/>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <Link to='/software/roadmap#search-optimization' className=' mx-auto'><button className='btn btn-yellow'>Learn More</button></Link>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default RoadmapTabs;